import { ElementType } from "../../dom-tools/ElementType";
import { Property } from "../../events/Property";
import { ComparableUIProperty, UIProperty } from "../basics/UIProperty";
import { LinkedGraphicalElement } from "../graphical/LinkedGraphicalElement";
import { ScrollBar } from "./ScrollBar";
import { ScrollContainer } from "./ScrollContainer";
import { UIComponent } from "./UIComponent";
import { Enums } from "../../tools/Enums";
import { isOneOf } from "../../tools/isOneOf";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { Margins } from "../basics/Margins";

export enum ScrollBarPositions
{
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT
}

export abstract class ScrollViewBase extends UIComponent
{
  static readonly elementType = new ElementType( "ui--scroll--view" );

  readonly scrollBarPositions  = new UIProperty<ScrollBarPositions>( this, ScrollBarPositions.BOTTOM_RIGHT );
  readonly scrollBarSize       = new UIProperty<number>( this, 20 );

  readonly horizontalScrollBar = new LinkedGraphicalElement<ScrollBar>( this );
  readonly horizontalScrollBarMargins = new UIProperty( this, Margins.NoMargins );

  readonly verticalScrollBar   = new LinkedGraphicalElement<ScrollBar>( this );
  readonly verticalScrollBarMargins = new UIProperty( this, Margins.NoMargins );

  readonly scrollContainer     = new LinkedGraphicalElement<ScrollContainer>( this );
  readonly scrollContainerMargins = new UIProperty( this, Margins.NoMargins );

  constructor()
  {
    super();
    
    this._createElement();

    //this._setElement( ScrollViewBase.elementType.create() );

    this._addListeners();

    this.blockRedraw();

    this.horizontalScrollBar.value = new ScrollBar();
    this.horizontalScrollBar.value.isHorizontal.value = true;

    this.verticalScrollBar.value = new ScrollBar();
    this.verticalScrollBar.value.isHorizontal.value = false;

    this.scrollContainer.value = new ScrollContainer();

    this.forceRedraw();
  }

  protected abstract _createElement():void;

  protected _addListeners()
  {
    this._linkRedraw(
      this.scrollBarPositions,
      this.scrollBarSize
    );

    this.scrollBarPositions.addListener(
      ( changeEvent )=>
      {
        let lastValue = changeEvent.lastValue;
        let newValue  = changeEvent.newValue;

        ClassFlag.fromEnum( ScrollBarPositions[ lastValue ], "ui--", ).removeFrom( this.element );
        ClassFlag.fromEnum( ScrollBarPositions[ newValue ], "ui--", ).set( this.element );
      }      
    );
    
  }

  _update()
  {
    super._update();

    var positions = this.scrollBarPositions.value;

    var onTop  = isOneOf( positions, ScrollBarPositions.TOP_LEFT, ScrollBarPositions.TOP_RIGHT );
    var onLeft = isOneOf( positions, ScrollBarPositions.TOP_LEFT, ScrollBarPositions.BOTTOM_LEFT );
    

    var scrollSize = this.scrollBarSize.value;

    //console.log( "Updating scroll view base:", this.dimensions.width, this.dimensions.height );

    if ( this.horizontalScrollBar.value )
    {

      this.horizontalScrollBar.value.dimensions.setWith(
        onLeft ? scrollSize : 0, 
        onTop ? 0 : ( this.height - scrollSize ),
        this.width - scrollSize,
        scrollSize, 
        this.horizontalScrollBarMargins.value
      );  
    }

    if ( this.verticalScrollBar.value )
    {

      this.verticalScrollBar.value.dimensions.setWith(
        onLeft ? 0 : ( this.width - scrollSize ),
        onTop ? scrollSize : 0,
        scrollSize,
        this.dimensions.height - scrollSize, 
        this.verticalScrollBarMargins.value
      ); 
    }

    if ( this.scrollContainer.value )
    {
      this.scrollContainer.value.dimensions.setWith( 
        onLeft? scrollSize : 0, 
        onTop ? scrollSize : 0,      
        this.width - scrollSize, 
        this.height - scrollSize,
        this.scrollContainerMargins.value
      );

    }
    

    
  }


}